import script from "./EquityReportIndex.vue?vue&type=script&setup=true&lang=ts"
export * from "./EquityReportIndex.vue?vue&type=script&setup=true&lang=ts"

import "./EquityReportIndex.vue?vue&type=style&index=0&id=b9f828e4&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9f828e4"]])

export default __exports__